import { gsap } from "gsap";

export default class BlockHero {
	constructor(block) {
		this.block = block;
		this.image = this.block.querySelector(".block-image");

		this.setStartingPositions();
		this.animateIn();
	}

	setStartingPositions() {
		gsap.set(this.image, {
			y: '25%',
			opacity: 0
		});
	}

	animateIn() {
		const tl = gsap.timeline();
		tl.to(this.image, {
			y: 0,
			opacity: 1,
			duration: 1,
			ease: "power4.out",
			delay: 1
		});
	}
}
